import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SeparatorComponent } from "./separator/separator.component";
import { ConditionalStepperComponent } from "./conditional-stepper/conditional-stepper.component";
import { PayoutItemComponent } from "./payout-item/payout-item.component";
import { DirectivesModule } from "@karma-games/angular-devkit/src/lib/modules/directives";
import { SharedComponentsModule } from "@karma-games/angular-devkit/src/lib/modules/shared-components";
import { ControlsComponentsModule } from "@karma-games/angular-devkit/src/lib/modules/controls-components";
import { NumberColorDirective } from "../directives/number-color/number-color.directive";

@NgModule({
    declarations: [
        SeparatorComponent,
        ConditionalStepperComponent,
        PayoutItemComponent,
        NumberColorDirective
    ],
    providers: [],
    imports: [
        CommonModule,
        DirectivesModule,
        SharedComponentsModule,
        ControlsComponentsModule
    ],
    exports: [
        SeparatorComponent,
        ConditionalStepperComponent,
        PayoutItemComponent,
        NumberColorDirective
    ]
})
export class ClientSharedComponentsModule {
}
